<template>
  <nav class="navbar navbar-expand-lg shadow-sm bg-body rounded navbar-light">
    <div class="container">
      <router-link :to="{ name: 'Home' }" custom v-slot="{ navigate }">
        <a
          role="link"
          class="navbar-brand"
          @click="navigate"
          @keypress.enter="navigate"
          title="To Home page"
        >
          <img
            :src="$store.state.config.frontpoint + '/storage/logo-newabc.png'"
            alt="Newabc App Logo"
            class=""
            height="80"
          />
        </a>
      </router-link>

      <button
        class="navbar-toggler"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav ms-auto mb-2 mb-lg-0 me-md-4">
          <li class="nav-item">
            <router-link :to="{ name: 'HowTo' }" custom v-slot="{ navigate }">
              <a
                role="link"
                class="nav-link"
                aria-current="page"
                @click="navigate"
                @keypress.enter="navigate"
              >
                How To Use
              </a>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'About' }" custom v-slot="{ navigate }">
              <a
                role="link"
                class="nav-link"
                aria-current="page"
                @click="navigate"
                @keypress.enter="navigate"
              >
                About us
              </a>
            </router-link>
          </li>
          <li class="nav-item">
            <router-link :to="{ name: 'Contact' }" custom v-slot="{ navigate }">
              <a
                role="link"
                class="nav-link"
                aria-current="page"
                @click="navigate"
                @keypress.enter="navigate"
              >
                Contact
              </a>
            </router-link>
          </li>
        </ul>
        <div class="d-flex">
          <elDropdown />
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import elDropdown from "../modules/account/components/Dropdown.vue";

export default {
  name: "Navbar",

  components: {
    elDropdown,
  },

  data() {
    return {
      navigate: {},
      search: "",
    };
  },

  mounted() {
    this.$nextTick(() => {});
  },

  methods: {},
};
</script>
